import React, { createContext, useCallback, useContext, useRef, useState } from "react"
import DocumentModal from "./DocumentModal"
import { DocumentType } from "../../../../../../../../packages/mp-shared-components/src/legal/documents"

export type { DocumentType } from "../../../../../../../../packages/mp-shared-components/src/legal/documents"

interface DocumentContextType {
  showDocument: boolean
  setDocumentAndVisibility: (type: DocumentType, visible: boolean) => void
}

export const DocumentContext = createContext<DocumentContextType | null>(null)
export const useDocumentContext = () => {
  const context = useContext(DocumentContext)
  if (!context) throw new Error("DocumentProvider is required")
  return context
}

const DocumentProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [documentType, setDocumentType] = useState<DocumentType | null>(null)
  const opener = useRef<HTMLElement | null>(null)
  const close = useCallback(() => {
    setDocumentType(null)
    const target = opener.current
    requestAnimationFrame(() => {
      if (target && document.contains(target)) target.focus({ preventScroll: true })
    })
  }, [])

  const setDocumentAndVisibility = useCallback((type: DocumentType, visible: boolean) => {
    if (!visible) {
      close()
      return
    }
    opener.current = document.activeElement as HTMLElement | null
    setDocumentType(type)
  }, [close])

  return (
    <DocumentContext.Provider value={{ showDocument: documentType !== null, setDocumentAndVisibility }}>
      {children}
      {documentType && <DocumentModal documentType={documentType} onClose={close} />}
    </DocumentContext.Provider>
  )
}

export default DocumentProvider
